import type { SVGProps } from "react";

/**
 * A macOS Finder–style folder — the same icon as the in-game app
 * (platform-2.0 design-system/Icon/MacFolderIcon, client 2026-09-28): a lighter blue back panel
 * with its tab, and a slightly darker front panel. Sized by `size`, so it
 * drops in wherever the old outline icon sat.
 */
export function MacFolderIcon({
  size = 14,
  open = false,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number; open?: boolean }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {/* back panel with the tab */}
      <path
        d="M2.5 6.5A2 2 0 0 1 4.5 4.5h4.6c.55 0 1.08.23 1.46.63l1.1 1.17c.38.4.9.63 1.46.63h6.38a2 2 0 0 1 2 2v9.57a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2z"
        fill="#7CB8F7"
      />
      {/* front panel */}
      <path
        d={
          open
            ? "M4.2 10.2h17.3a1.2 1.2 0 0 1 1.17 1.46l-1.55 6.9a1.6 1.6 0 0 1-1.56 1.24H3.6a1.1 1.1 0 0 1-1.08-1.32l1.4-7.3A1.3 1.3 0 0 1 4.2 10.2z"
            : "M2.5 9.4h19v9.1a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2z"
        }
        fill="#4A9BEF"
      />
      {/* the top edge highlight of the front panel */}
      <path
        d={open ? "M4.2 10.2h17.3v.9H4.1z" : "M2.5 9.4h19v.9h-19z"}
        fill="#5FAAF5"
      />
    </svg>
  );
}
